<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "PJProposalLimitOfLiability",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>E. Limit of Liability of Insurer at Different Location(s)</div>"
					},
					bindTo: ""
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>If Insured Property is to be taken out from bank deposit box, what will be the MAXIMUM VALUE of such Insured Property under the following situations:-</div>"
					},
					bindTo: ""
				},
				{
					label: "a) at or within Named Location(s) and / or",
					component: "text",
					bindTo: "case.facts.limitOfLiabilityAtOrWithinNamedLocation"
				},
				{
					label: "b) outside or away from Named Location(s)",
					component: "text",
					bindTo: "case.facts.limitOfLiabilityOutsideOrAwayFromNamedLocation"
				}
			]
		}
	}
}
</script>
